import styled, { css } from 'styled-components';
import { tagStyles } from '../../ui/Typography/styles';
import { Breakpoints } from '../../../styled/constants';

export const AgencyContactsContainer = styled.div`
  padding-top: 20px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    width: 345px;
    flex: 0 0 auto;
  }
`;

const agencyContactStyles = css`
  display: flex;
  gap: 10px;
  padding-left: 26px;
  position: relative;
  box-sizing: border-box;
  ${tagStyles.body_1};

  &::before {
    content: '';
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const AgencyContactAddress = styled.a`
  ${agencyContactStyles};
  color: ${({ theme }) => theme.colors.systemColors.blue};
  margin-bottom: 15px;
  ${tagStyles.title_4_new};
  text-decoration-line: underline;

  &::before {
    background-image: url('/static/images/map_row.svg');
    width: 17px;
    height: 20px;
  }
`;

export const AgencyContactTimetable = styled.div`
  ${agencyContactStyles};
  margin-bottom: 20px;

  &::before {
    background-image: url('/static/images/clock.svg');
    width: 18px;
    height: 18px;
    margin: auto;
  }
`;
